import React from 'react';

export const MainPageText = {
  ru: {
    about: 'О нас',
    equipment: 'Оборудование',
    projects: 'Проекты',
    contacts: 'Контакты',
    vacancy: 'Вакансии',

    homeHead: 'ДИСТРИБЬЮТОР И СЕРВИС ПАРТНЕР',
    homeTitle: 'В Молдове',

    secondTitle: 'О компании VIPROPAT SRL',
    secondAbout: (
      <>
        <p>
          Компания <b>VIPROPAT SRL</b> — ведущий интегратор комплексных энергетических решений в
          Молдове. Мы специализируемся на проектировании, поставке, монтаже, пусконаладке,
          гарантийном и сервисном обслуживании газопоршневых электростанций, когенерационных и
          тригенерационных систем на базе оборудования <b>INNIO Jenbacher</b> (Австрия). VIPROPAT
          SRL является официальным уполномоченным дистрибьютором INNIO Jenbacher в Республике
          Молдова, что подтверждает наш высокий уровень технической компетенции и доступ к
          оригинальным технологиям и сервисным ресурсам производителя.
        </p>
        <p>
          Мы предлагаем современные решения для производства электрической и тепловой энергии
          (когенерация), а также холода (тригенерация) на базе газопоршневых установок Jenbacher.
          Наши специалисты обеспечивают полный цикл реализации проектов «под ключ» — от инженерного
          анализа и разработки концепции до ввода в эксплуатацию и долгосрочного сопровождения.
        </p>
        <p>
          Дополняя наше портфолио, VIPROPAT SRL является официальным представителем одного из
          мировых лидеров в области абсорбционных холодильных машин — <b>BROAD</b>. Это позволяет
          нам интегрировать в проекты высокоэффективные абсорбционные чиллеры, работающие на
          тепловой энергии, вырабатываемой когенерационными установками Jenbacher.
        </p>
        <p>
          Такой технологический тандем <b>Jenbacher + BROAD</b> обеспечивает:
        </p>
      </>
    ),
    secondAboutList: [
      'максимальную энергоэффективность и снижение эксплуатационных затрат;',
      'производство холода без использования электричества;',
      'повышение общей эффективности установки до 85–90%;',
      'устойчивость и автономность энергетической инфраструктуры;',
      'экологичность и снижение выбросов CO₂.',
    ],
    secondAboutFooter:
      'Благодаря сочетанию передовых газопоршневых технологий INNIO Jenbacher и инновационных абсорбционных решений BROAD, мы создаём комплексные энергетические системы нового поколения, адаптированные под промышленные, коммерческие и муниципальные объекты.',

    aouLeftH: 'Области применения:',
    aouLeftT1: 'Источники энергоснабжения районных и городских централизованных систем;',
    aouLeftT2: 'Пиковые блок-станции;',
    aouLeftT3: 'Индивидуальные системы электро- и теплоснабжения для:',
    aouLeftLi1: 'предприятий промышленности и сельского хозяйства',
    aouLeftLi2: 'гостиниц, баз отдыха и спортивных центров',
    aouLeftLi3: 'супер- и гипермаркетов, торговых центров',
    aouLeftLi4: 'жилых массивов и административных комплексов',
    aouLeftLi5: 'больниц, лечебных заведений',
    aouLeftLi6: 'портов и аэропортов',
    aouLeftT4:
      'Составная часть комбинированных систем энергообеспечения на базе возобновляемых источников энергии.',
    aouLeftT5:
      'Используя индивидуальный и гибкий подход к каждому клиенту, мы выполняем обязательную предпроектную проработку каждого объекта с целью предоставления клиенту информации о сроках окупаемости и экономической эффективности проекта.',
    aouLeftT6:
      'Миссия нашей компании — развитие энергетики и укрепление энергетической безопасности Республики Молдова.',
    aouLeftT7:
      'Установка собственной мини-ТЭЦ сделает ваш бизнес более стабильным, независимым и прибыльным за счёт надёжного энергоснабжения по выгодным тарифам.',

    aouRightH: 'Диапазон технических решений:',
    aouRightLi1: 'Электрическая мощность энергоблоков от 300 кВт до 30 МВт.',
    aouRightLi2: 'Исполнение энергоблоков — контейнерное, модульное.',
    aouRightLi3: 'Топливо — природный газ, биогаз, сжиженный газ (пропан).',
    aouRightLi4: 'Выходное напряжение — 0,4 кВ, 6,3 кВ, 10 кВ.',

    project: 'Наши проекты',

    news: 'Новости',
    news1:
      'С 17 по 20 марта в Международном выставочном центре «Moldexpo» прошла XIV Международная специализированная выставка энергосберегающих технологий, систем отопления, газоснабжения и кондиционирования воздуха «MOLDENERGY-2010»…',
    news2:
      'INNIO завершает отделение от General Electric и становится независимой энергетической компанией',
    news3:
      '1 сентября 2013 года в Бендерах состоялся запуск когенерационной установки ГУП «Биохим»…',

    articles: 'Статьи',
    articles1: 'Мощностной ряд газопоршневого когенерационного оборудования',
    articles2: 'Когенерация',
    articles3: 'Использование CO2 в теплицах',
    articles4: 'Биогаз',
    articles5: 'Газ мусорных свалок',
    articles6: 'Тригенерация',

    contactArea: 'Мы находимся',
    contactAdress:
      'Республика Молдова, MD-2068, г. Кишинёв, ул. Мирон Костин, 7 (правое крыло), оф. 408',

    writeEmail: 'Напишите нам!',
    writeEmailName: 'Ваше имя',
    writeEmailAdress: 'Электронная почта',
    writeEmailTheme: 'Тема',
    writeEmailMessage: 'Сообщение',
    writeEmailSend: 'ОТПРАВИТЬ',
  },

  md: {
    about: 'Despre noi',
    equipment: 'Produse',
    projects: 'Proiectele',
    contacts: 'Date de contact',
    vacancy: 'Locuri de muncă',

    homeHead: 'DISTRIBUITOR ȘI PARTENER DE SERVICIU',
    homeTitle: 'În Moldova',

    secondTitle: 'Despre compania VIPROPAT SRL',
    secondAbout: (
      <>
        <p>
          Compania <b>VIPROPAT SRL</b> — lider în soluții energetice integrate în Moldova. Ne
          specializăm în proiectarea, furnizarea, instalarea, punerea în funcțiune, întreținerea în
          garanție și service-ul centralelor cu motoare pe gaz, a sistemelor de cogenerare și
          trigenerare bazate pe echipamente <b>INNIO Jenbacher</b> (Austria). VIPROPAT SRL este
          distribuitor oficial autorizat INNIO Jenbacher în Republica Moldova, ceea ce confirmă
          nivelul nostru ridicat de competență tehnică și accesul la tehnologiile și resursele de
          service originale ale producătorului.
        </p>
        <p>
          Oferim soluții moderne pentru producerea energiei electrice și termice (cogenerare),
          precum și a frigului (trigenerare) pe baza instalațiilor cu motoare pe gaz Jenbacher.
          Specialiștii noștri asigură ciclul complet de implementare a proiectelor „la cheie" — de
          la analiza inginerească și dezvoltarea conceptului până la punerea în funcțiune și
          asistența pe termen lung.
        </p>
        <p>
          Completând portofoliul nostru, VIPROPAT SRL este reprezentantul oficial al unuia dintre
          liderii mondiali în domeniul mașinilor frigorifice cu absorbție — <b>BROAD</b>. Acest
          lucru ne permite să integrăm în proiecte chillere cu absorbție de înaltă eficiență, care
          funcționează pe baza energiei termice produse de instalațiile de cogenerare Jenbacher.
        </p>
        <p>
          Acest tandem tehnologic <b>Jenbacher + BROAD</b> asigură:
        </p>
      </>
    ),
    secondAboutList: [
      'eficiență energetică maximă și reducerea costurilor de exploatare;',
      'producerea frigului fără utilizarea energiei electrice;',
      'creșterea eficienței totale a instalației până la 85–90%;',
      'stabilitatea și autonomia infrastructurii energetice;',
      'ecologicitate și reducerea emisiilor de CO₂.',
    ],
    secondAboutFooter:
      'Datorită combinației dintre tehnologiile avansate cu motoare pe gaz INNIO Jenbacher și soluțiile inovatoare de absorbție BROAD, creăm sisteme energetice complexe de nouă generație, adaptate pentru obiective industriale, comerciale și municipale.',

    aouLeftH: 'Domenii de aplicare:',
    aouLeftT1: 'Surse de aprovizionare a sistemelor centralizate raionale și urbane;',
    aouLeftT2: 'Stații generatoare de vârf;',
    aouLeftT3: 'Sisteme individuale de alimentare cu energie electrică și termică pentru:',
    aouLeftLi1: 'producătorii industriali şi agricultura',
    aouLeftLi2: 'hoteluri, centre de recreere și centre sportive',
    aouLeftLi3: 'super și hiper piețe, mall-uri',
    aouLeftLi4: 'zone rezidențiale și complexe administrative',
    aouLeftLi5: 'spitale, instituții medicale',
    aouLeftLi6: 'porturi și aeroporturi',
    aouLeftT4:
      'Componentă a sistemelor energetice combinate bazate pe surse regenerabile de energie.',
    aouLeftT5:
      'Aplicând o abordare individuală și flexibilă pentru fiecare client, purtăm o pre-proiectare obligatorie a fiecărui obiect pentru a furniza clientului informații despre momentul amortizării și eficiența costurilor proiectului.',
    aouLeftT6:
      'Misiunea companiei noastre – dezvoltarea sectorului energetic și sporirea securității energetice a Republicii Moldova.',
    aouLeftT7:
      'Setarea propriei centrale electrice va face afacerea dvs. mai stabilă, independentă și profitabilă în detrimentul energiei fiabile la prețuri competitive.',

    aouRightH: 'Gama de soluții tehnice:',
    aouRightLi1: 'Puterea de ieșire electrică de la 300 kW la 30 MW.',
    aouRightLi2: 'Execuția unităților — containerizată sau modulară.',
    aouRightLi3: 'Combustibil — gaz natural, biogaz, gaz petrolier lichefiat (propan).',
    aouRightLi4: 'Tensiune de ieșire — 0,4 kV, 6,3 kV sau 10 kV.',

    project: 'Proiectele noastre',

    news: 'NOUTĂȚI',
    news1:
      'În perioada 17–20 martie, la Centrul Internațional de Expoziții „Moldexpo”, a avut loc cea de-a XIV-a Expoziție Internațională Specializată de Tehnologii de Economisire a Energiei, Sisteme de Încălzire, Alimentare cu Gaz și Climatizare „MOLDENERGY-2010”…',
    news2:
      'INNIO finalizează separarea de General Electric și devine o companie independentă de energie',
    news3:
      'La 1 septembrie 2013, la Bender, a fost lansată unitatea de cogenerare a Întreprinderii Unitare de Stat „Biochim”…',

    articles: 'Articole',
    articles1: 'Gama de putere a echipamentelor de cogenerare cu piston pe gaz',
    articles2: 'Cogenerare',
    articles3: 'Utilizarea CO2 în sere',
    articles4: 'Biogaz',
    articles5: 'Gaz de depozitare',
    articles6: 'Trigenerare',
    contactArea: 'Locația noastră',
    contactAdress:
      'Republica Moldova, MD-2068, mun. Chișinău, str. Miron Costin, 7 (aripa dreaptă), of. 408',

    writeEmail: 'Scrieți-ne!',
    writeEmailName: 'Numele dumneavoastră',
    writeEmailAdress: 'Email',
    writeEmailTheme: 'Temă',
    writeEmailMessage: 'Mesaj',
    writeEmailSend: 'TRIMITE',
  },

  en: {
    about: 'About us',
    equipment: 'Products',
    projects: 'Projects',
    contacts: 'Contacts',
    vacancy: 'Vacancies',

    homeHead: 'DISTRIBUTOR AND SERVICE PARTNER',
    homeTitle: 'IN MOLDOVA',

    secondTitle: 'About VIPROPAT SRL',
    secondAbout: (
      <>
        <p>
          <b>VIPROPAT SRL</b> is a leading integrator of comprehensive energy solutions in Moldova.
          We specialize in design, supply, installation, commissioning, warranty, and service
          maintenance of gas engine power plants, cogeneration and trigeneration systems based on{' '}
          <b>INNIO Jenbacher</b> equipment (Austria). VIPROPAT SRL is an authorized official
          distributor of INNIO Jenbacher in the Republic of Moldova, confirming our high level of
          technical competence and access to original technologies and manufacturer's service
          resources.
        </p>
        <p>
          We offer modern solutions for generating electrical and thermal energy (cogeneration), as
          well as cooling (trigeneration) based on Jenbacher gas engine units. Our specialists
          ensure the full project implementation cycle on a "turnkey" basis — from engineering
          analysis and concept development to commissioning and long-term support.
        </p>
        <p>
          Complementing our portfolio, VIPROPAT SRL is the official representative of one of the
          world leaders in absorption chillers — <b>BROAD</b>. This allows us to integrate highly
          efficient absorption chillers into projects, operating on thermal energy generated by
          Jenbacher cogeneration units.
        </p>
        <p>
          This technological tandem <b>Jenbacher + BROAD</b> provides:
        </p>
      </>
    ),
    secondAboutList: [
      'maximum energy efficiency and reduction of operating costs;',
      'cooling production without electricity consumption;',
      'increase of total installation efficiency up to 85–90%;',
      'stability and autonomy of energy infrastructure;',
      'environmental sustainability and reduction of CO₂ emissions.',
    ],
    secondAboutFooter:
      'By combining advanced INNIO Jenbacher gas engine technologies with innovative BROAD absorption solutions, we create next-generation integrated energy systems adapted for industrial, commercial, and municipal facilities.',

    aouLeftH: 'Application areas:',
    aouLeftT1: 'Supply sources of district and urban centralized systems;',
    aouLeftT2: 'Peak generating stations;',
    aouLeftT3: 'Individual electricity and heat supply systems for:',
    aouLeftLi1: 'industrial manufacturers and agriculture',
    aouLeftLi2: 'hotels, recreation centers and sports centers',
    aouLeftLi3: 'super and hyper markets, malls',
    aouLeftLi4: 'residential areas and administrative complexes',
    aouLeftLi5: 'hospitals, medical institutions',
    aouLeftLi6: 'ports and airports',
    aouLeftT4: 'Component of the combined energy systems based on renewable sources of energy.',
    aouLeftT5:
      'Applying an individual and flexible approach to each client, we carry a mandatory pre-design of each object to provide to the client information on the timing of payback, and project cost effectiveness.',
    aouLeftT6:
      "Our company's mission is to develop the energy sector and strengthen the energy security of the Republic of Moldova.",
    aouLeftT7:
      'Setting your own power station will make your business more stable, independent and profitable at the expense of reliable energy at competitive prices.',

    aouRightH: 'The range of technical solutions:',
    aouRightLi1: 'Electrical output power from 300 kW to 30 MW.',
    aouRightLi2: 'Unit configuration — containerized or modular.',
    aouRightLi3: 'Fuel — natural gas, biogas, or liquefied petroleum gas (propane).',
    aouRightLi4: 'Output voltage — 0.4 kV, 6.3 kV, or 10 kV.',

    project: 'Our projects',

    news: 'NEWS',
    news1:
      'From 17 to 20 March, the 14th International Specialized Exhibition of Energy-Saving Technologies, Heating Systems, Gas Supply, and Air Conditioning, “MOLDENERGY-2010”, was held at the Moldexpo International Exhibition Centre.',
    news2:
      'INNIO completes separation from General Electric and becomes an independent energy company',
    news3:
      'On 1 September 2013, the cogeneration unit of the State Unitary Enterprise “Biochim” was launched in Bender…',

    articles: 'Articles',
    articles1: 'Power range of gas-piston cogeneration equipment',
    articles2: 'Cogeneration',
    articles3: 'CO2 use in greenhouses',
    articles4: 'Biogas',
    articles5: 'Landfill gas',
    articles6: 'Trigeneration',

    contactArea: 'Our location',
    contactAdress:
      'Republic of Moldova, MD-2068, 7 Miron Costin Street (right wing), office 408, Chișinău',

    writeEmail: 'Write to us!',
    writeEmailName: 'Your name',
    writeEmailAdress: 'Email address',
    writeEmailTheme: 'Subject',
    writeEmailMessage: 'Message',
    writeEmailSend: 'SEND',
  },
};
